@for (file of getFilesById(); track $index) {
  <app-file-card
    [fileCard]="{
      id: file.id,
      fileParams: file.file,
      fileType: 'DECLARATION',
      isEditModeActive: isEditModeActive(),
      shouldCheckImageType: false
    }"
    (handleDelete)="handleDelete($event, file)"
  />
}
<app-file-upload-card
  [fileUploadParams]="{
    parentId: declarationId(),
    recordId: declarationId(),
    type: `DECLARATION-${declarationId()}`,
    entityFileType: 'DECLARATION'
  }"
  [isEditModeActive]="isEditModeActive()"
  (attachFile)="attachFile($event)"
/>
